import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { FilterList, FilterListItem } from 'react-admin';

import { ListFilterSidebar } from '@/components/filters/ListFilterSidebar';
import { defaultTicketStatuses } from '@/root/defaultConfiguration';

export const TicketListFilter = () => (
    <ListFilterSidebar searchPlaceholder="Search tickets">
        <FilterList label="Status" icon={<TrendingUpIcon />}>
            <FilterListItem label="Show all" value={{ status: undefined }} />
            {defaultTicketStatuses.map(status => (
                <FilterListItem
                    key={status.value}
                    label={status.label}
                    value={{ status: Number(status.value) }}
                />
            ))}
        </FilterList>
    </ListFilterSidebar>
);
